(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfAutoSelectOnlyOption', function() {
    return {
      restrict: 'A',
      require: 'uiSelect',
      link: (function(_this) {
        return function(scope, element, attrs, uiSelect) {
          if (scope.$eval(attrs.mfAutoSelectOnlyOption) === false) {
            return;
          }
          return scope.$watchCollection('$select.items', function(items) {
            var ref, selected;
            if (uiSelect.search !== '') {
              return;
            }
            if ((items != null ? items.length : void 0) === 1) {
              selected = scope.$select.selected;
              if (selected === items[0] || (((selected != null ? selected.id : void 0) != null) && (((ref = items[0]) != null ? ref.id : void 0) != null) && selected.id === items[0].id)) {
                return;
              }
              return scope.$evalAsync(function() {
                return scope.$select.select(items[0]);
              });
            }
          });
        };
      })(this)
    };
  });

}).call(this);
